// extracted by mini-css-extract-plugin
export default {"container":"style_container__u-ydd","header":"style_header__Lz9a7"};